import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getActivityList(pageNum,pageSize) {
  return request({
    url: '/activity/getActivityList',
    params: {
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function getActivityById(id) {
  return request({
    url: '/activity/getById',
    params: {
      activityId:id
    }
  })
}

export function updateActivity(activity) {
  return requestMsg({
    url: '/activity/updateActivity',
    data: JSON.stringify(activity),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}
